import React from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Layout from './Components/Layout';
import PrivateAdminRoute from './Resources/Auth/PrivateAdminRoute';
import PrivateUserRoute from './Resources/Auth/PrivateUserRoute';
import Login from './Pages/Auth/Login';
import ForgotPassword from './Pages/Auth/ForgotPassword';
import AttInterface from './Pages/AttInterface';
import Page404 from './Pages/Common/Page404';
import Page500 from './Pages/Common/Page500';
import { getSettings } from './Redux/Actions/SettingsAction'
import { toast } from 'react-toastify';

const App = () => {
  const reducerToken = useSelector(state => state.authReducer.tokenPayload);
  { reducerToken && reducerToken === undefined && localStorage.removeItem("accessToken") }
  const authToken = localStorage.getItem('accessToken');
  // console.log(authToken)
  const dispatch = useDispatch()
  React.useEffect(() => {
    if (authToken !== null) {
      dispatch(getSettings(authToken, toast))
    }
  }, [])
  const history = useHistory()

  return (
    <React.Fragment>
    <Router history={history}>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <PrivateUserRoute path="/attendance" component={AttInterface} />
        <PrivateAdminRoute path="/" render={props => <Layout {...props} />} />
        <Route path="*" component={Page404} />
      </Switch>
    </Router>
    </React.Fragment>
  );
}

export default App